import React from 'react';

import { ListGroup } from 'react-bootstrap';
import { Link } from "react-router-dom";

import Pattern from 'style/bluepattern.png'
import './Sidebar.css'

function Sidebar({ title, root }) {
    function Items() {
        let a = ['공지사항', '문의게시판', '연간 기부금 모금액 내역', '기부금 활용 실적 내역', '보도자료']
        let b = ['대회일정 및 신청', '대회결과']
        let c = ['코치과정안내', '코치과정공지', '심판과정안내', '심판과정공지']
        let d = ['인사말', '연혁', '조직도', '오시는길']
        let items = ''
        if (a.indexOf(title) >= 0)
            items = <ListGroup className="sidebarText" >
                <Link to="/notice" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item >· 공지사항</ListGroup.Item>
                </Link>
                {/* <Link to="/qna" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item >· 문의게시판</ListGroup.Item>
                </Link> */}
                <Link to="/donationhistory" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item >· 연간 기부금 모금액 내역</ListGroup.Item>
                </Link>
                <Link to="/donationusing" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item >· 기부금 활용 실적 내역</ListGroup.Item>
                </Link>
                <Link to="/article" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item >· 보도자료</ListGroup.Item>
                </Link>
            </ListGroup >
        else if (b.indexOf(title) >= 0)
            items = <ListGroup className="sidebarText">
                <Link to="/matchschedule" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item>· 대회일정 및 신청</ListGroup.Item>
                </Link>
                <Link to="/matchresult" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item>· 대회결과</ListGroup.Item>
                </Link>
                {/* <Link to="/participate" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item>· 온라인 참가신청</ListGroup.Item>
                </Link> */}
            </ListGroup >
        else if (c.indexOf(title) >= 0)
            items = <ListGroup className="sidebarText" >
                <Link to="/coachinfo" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item>· 코치과정안내</ListGroup.Item>
                </Link>
                <Link to="/coachnotice" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item>· 코치과정공지</ListGroup.Item>
                </Link>
                <Link to="/refereeinfo" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item>· 심판과정안내</ListGroup.Item>
                </Link>
                <Link to="/refereenotice" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item>· 심판과정공지</ListGroup.Item>
                </Link>
            </ListGroup >
        else if (d.indexOf(title) >= 0)
            items = <ListGroup className="sidebarText">
                <Link to="/welcome" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item>· 인사말</ListGroup.Item>
                </Link>
                <Link to="/history" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item>· 연혁</ListGroup.Item>
                </Link>
                <Link to="/chart" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item>· 조직도</ListGroup.Item>
                </Link>
                <Link to="/map" style={{ textDecoration: 'none' }}>
                    <ListGroup.Item>· 오시는길</ListGroup.Item>
                </Link>
            </ListGroup >
        else
            items = <></>
        return items
    }

    return (
        <div className="d-none d-md-inline-block " style={{ textAlign: 'left', justifyContent: "center" }}>
            <div className="h5 align-middle d-table-cell sidebar " style={{ background: `url(${Pattern})`, backgroundRepeat: "repeat", color: "white", height: 120, textAlign: "center", justifyContent: "center" }}>
                {
                    title === '연간 기부금 모금액 내역' ?
                        <>연간 기부금<br />모금액 내역</> :
                        title === '기부금 활용 실적 내역' ?
                            <>기부금 활용<br />실적 내역</> :
                            title
                }
            </div>
            <div className="sidebar " >
                <Items />
            </div>
        </div >
    );
}

export default Sidebar;